import styled, { css } from 'styled-components'
import posed from 'react-pose'

const StyledIconPosed = posed.span({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});

export const IconStyled = styled(StyledIconPosed)`
  display: block;
  line-height: 0;
  opacity: 1;
  ${({ pointer }) =>
    pointer &&
    css`
          cursor: pointer;
        `
  };
  ${({ center }) =>
    center &&
    css`
          margin: 0 auto;
        `
  };
`;